import React from "react";
//#region types
import { IncomingInvoiceInternationalPaymentViewFooterProps } from "models/propTypes/incomingInvoicePropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { ToggleSwitch } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";

const IncomingInvoiceInternationalPaymentViewFooter: React.FC<IncomingInvoiceInternationalPaymentViewFooterProps> = (
  props
) => {
  return (
    <Grid container direction="column" flexWrap="nowrap" spacing={2}>
      <Grid item className={cssExports.contentFooter}>
        {LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.IncomingInvoice.InternationalPaymentViewHelpText
        )}
      </Grid>
      <Grid
        item
        container
        alignItems="center"
        spacing={2}
        direction="row"
        justifyContent="space-between"
        flexWrap="nowrap"
      >
        <Grid item className={cssExports.textBlack}>
          {LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.IncomingInvoice.InternationalPaymentAndAddressToggleLabel
          )}
        </Grid>
        <Grid item>
          <ToggleSwitch checked={!!props.isAccepted} onChange={props.onChange} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default IncomingInvoiceInternationalPaymentViewFooter;
